import Table, {
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@/components/Table';
import MuiCollapse from '@mui/material/Collapse';
import InvestmentRow from './InvestmentRow';
import { sortByKey } from '@/utils/arrays';
import {
  useHasCompanyAccess,
  useInvestorCompany,
  useLatestFinancialReport,
} from '@/hooks/useStore';
import { classes } from './utils';

export type InvestmentHistoryRowProps = {
  open: boolean;
  companyId: number;
  investorId: number;
};

export default function InvestmentHistoryRow({
  open,
  companyId,
  investorId,
}: InvestmentHistoryRowProps) {
  // TODO: Currency
  const investorCompany = useInvestorCompany(companyId, investorId);
  const latestReport = useLatestFinancialReport(companyId);
  const hasCompanyAccess = useHasCompanyAccess();

  if (!investorCompany) return null; // TODO

  const { investments } = investorCompany;

  return (
    <TableRow className={classes.row}>
      <TableCell
        className={classes.wrapperCell}
        colSpan={hasCompanyAccess ? 9 : 8}>
        <MuiCollapse in={open} timeout="auto" unmountOnExit>
          <Table size="small" className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell className={classes.headCell} />
                <TableCell className={classes.headCell} align="left">
                  Date
                </TableCell>
                {[
                  'Shares',
                  'Price',
                  'Amt. Invested',
                  'Current Price',
                  'Current Value',
                  'Profit/Loss',
                ].map((label) => (
                  <TableCell
                    key={label}
                    className={classes.headCell}
                    align="right">
                    {label}
                  </TableCell>
                ))}
                <TableCell className={classes.headCell} />
              </TableRow>
            </TableHead>
            <TableBody>
              {sortByKey(investments, 'date').map((investment) => (
                <InvestmentRow
                  key={investment.id}
                  companyId={investment.companyId}
                  investorId={investment.investorId}
                  investmentId={investment.id}
                  latestFinancialReport={latestReport}
                />
              ))}
            </TableBody>
          </Table>
        </MuiCollapse>
      </TableCell>
    </TableRow>
  );
}
